export const initialValues = {
    employerType: new URLSearchParams(window.location.search).get('employerType') || 'polish',
    employerCompanyName: '',
    nip: '',
    dateOfIllness: new Date(),
    dateOfBackToWork: new Date(),
    importantInformation: '',
    uploadedFile: null,
    agreement: false,
    personalInformation: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        address: '',
        houseNumber: '',
        city: '',
        zipCode: '',
        pesel: '',
    },
};
